module.exports = __webpack_public_path__ + "static/img/yk6300.f241777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk6300.png
// module id = BHZu
// module chunks = 1